<script setup>
const props = defineProps({
  customClass: String,
  size: String,
});

const sizeClass = ref(
  props.size ? "w-" + props.size + " h-" + props.size : "w-24px h-24px"
);
</script>

<template>
<svg
  class="icon icon--chevron-down"
  :class="[sizeClass, customClass]"
  viewBox="0 0 24 24"
  stroke-width="2"
  stroke="currentColor"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  aria-hidden="true"
>
  <path
    stroke-linecap="round"
    stroke-linejoin="round"
    d="m4.5 8.25 7.5 7.5 7.5-7.5"
  />
</svg>
</template>
